import React from 'react';
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';

const About = () => {
  const missionHeader = {
    title: 'About SEES INTERNATIONAL',
    paragraph: 'At SEES INTERNATIONAL, we are a modern, US-headquartered global trade and enterprise solutions group operating at the intersection of international commerce, digital infrastructure, and strategic brokerage. Designed for agile cross-border trade, we connect high-growth industries across the Americas, Asia, Europe, and the Middle East & Africa (MEA).'
  };

  const partnerHeader = {
    title: 'Single Gateway for Global Trade & Tech',
    paragraph: 'Built on a foundation of global sourcing power, market intelligence, and multi-regional logistics pipelines, SEES INTERNATIONAL serves as a single, high-trust gateway for enterprises looking to buy, sell, scale, or transform. From leveraging premier trade routes and major UAE maritime ports for seamless East-West distribution to deploying enterprise IT architecture and executing high-value commodity deals, we deliver end-to-end operational solutions built for the modern global market.'
  };

  return (
    <>
      <Hero />
      
      <GenericSection topDivider>
        <SectionHeader data={missionHeader} className="center-content" />
      </GenericSection>

      <GenericSection topOuterDivider>
        <SectionHeader data={partnerHeader} className="center-content" />
        
        <div className="container-xs">
          {/* Corporate Foundation & History Highlight */}
          <div className="p-32 mb-32" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B' }}>
            <h3 className="mt-0 mb-12" style={{ color: '#A88756' }}>Our History & Foundation</h3>
            <p className="text-sm m-0" style={{ color: '#CBD5E1', lineHeight: '1.8' }}>
              Established in the <strong>United States in early 2021</strong>, SEES INTERNATIONAL has built a proven track record of executing high-value commercial trade and digital enterprise operations globally. Over years of successful global business, we have expanded our footprint across North America, Europe, Asia, and the Middle East & Africa (MEA), serving as a trusted, high-resilience partner for enterprise clients worldwide.
            </p>
          </div>

          <div className="p-32 mb-24" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B' }}>
            <h4 className="mt-0 mb-16" style={{ color: '#A88756' }}>Our Strategic Pillars</h4>
            <ul className="text-sm" style={{ color: '#CBD5E1', lineHeight: '1.8', listStyle: 'none', padding: 0, margin: 0 }}>
              <li className="mb-12">
                <strong style={{ color: '#A88756' }}>🇺🇸 US Headquarters & Governance:</strong> Established in early 2021 with central executive leadership, corporate compliance, and strategic management.
              </li>
              <li className="mb-12">
                <strong style={{ color: '#A88756' }}>🇦🇪 UAE Maritime Ports & Gateway:</strong> Central re-export hubs and ocean/air freight staging for seamless East-West distribution.
              </li>
              <li className="mb-12">
                <strong style={{ color: '#A88756' }}>🌍 Global Sourcing Network:</strong> Direct procurement across manufacturing hubs in Asia, North America, Europe, and the GCC.
              </li>
              <li className="mb-12">
                <strong style={{ color: '#A88756' }}>💻 Enterprise Digital Infrastructure:</strong> End-to-end IT deployment, SaaS asset management, and performance marketing lead engines.
              </li>
            </ul>
          </div>
        </div>
      </GenericSection>

      <FeaturesTiles topDivider />
    </>
  );
};

export default About;
